import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ExcluirEstoqueNotaFiscalEntradaDialogData } from './excluir-estoque-nota-fiscal-entrada-dialog-data';

@Component({
  selector: 'app-excluir-estoque-nota-fiscal-entrada-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  templateUrl: './excluir-estoque-nota-fiscal-entrada-dialog.component.html',
  styleUrl: './excluir-estoque-nota-fiscal-entrada-dialog.component.css',
})
export class ExcluirEstoqueNotaFiscalEntradaDialogComponent {
  readonly justificativa = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required, Validators.minLength(10), Validators.maxLength(500)],
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ExcluirEstoqueNotaFiscalEntradaDialogData,
    private dialogRef: MatDialogRef<ExcluirEstoqueNotaFiscalEntradaDialogComponent>
  ) {}

  cancelar(): void {
    this.dialogRef.close();
  }

  confirmar(): void {
    this.justificativa.markAsTouched();
    if (this.justificativa.invalid) return;
    this.dialogRef.close(this.justificativa.value.trim());
  }
}
